import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  width: "100%",
});
